import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { LayoutRoute } from 'common/components';
import { LoginLayout, PageNotFoundLayout } from 'common/layouts';
import DefaultLayout from 'common/layouts/defaultLayout';
import {
    getIsGuess,
    getSessionLocalStorage,
} from 'common/utils/helpers/session';

import companies from '../companies';
import company from '../company';
import documents from '../documents';
import editTemplateView from '../editTemplateView';
import login from '../login';
import multiTemplateReview from '../multiTemplateReview';
import products from '../products';
import profile from '../profile';
import proposals from '../proposals';
import systems from '../systems';

const PageNotFound = () => <div>404 - Page Not Found</div>;

const Container = ({ setCurrentValues }) => {
    const session = getSessionLocalStorage();
    useEffect(() => {
        if (!getIsGuess()) {
            setCurrentValues(session);
        }
    }, []);

    return (
        <Switch>
            <LayoutRoute
                component={login.Container}
                isPublic
                layout={LoginLayout}
                path="/login"
                exact
            />
            <LayoutRoute
                component={company.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[1]}
                path={[
                    '/company-file',
                    '/company-file/:id',
                    '/company-file/:id/:tab',
                ]}
                exact
            />
            <LayoutRoute
                component={products.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[2]}
                path={[
                    '/products',
                    '/products/:section',
                    '/products/:section/:tab',
                ]}
                exact
            />
            <LayoutRoute
                component={proposals.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[2]}
                path="/proposals"
                exact
            />
            <LayoutRoute
                component={multiTemplateReview.Container}
                isPublic
                layout={DefaultLayout}
                path="/proposals/preview/:uid"
                exact
            />
            <LayoutRoute
                component={systems.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[3]}
                path="/systems"
                exact
            />
            <LayoutRoute
                component={documents.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[3]}
                path={['/documents', '/documents/:tab']}
                exact
            />
            <LayoutRoute
                component={profile.Container}
                isPrivate
                layout={DefaultLayout}
                path="/profile"
                exact
            />
            <LayoutRoute
                component={editTemplateView.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[3]}
                path="/templates/edition/:uid"
                exact
            />
            <LayoutRoute
                component={companies.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[1]}
                path="/companies"
                exact
            />
            <LayoutRoute
                component={companies.Container}
                isPrivate
                layout={DefaultLayout}
                requiredPermissions={[1]}
                path="/"
                exact
            />
            <LayoutRoute
                component={PageNotFound}
                layout={PageNotFoundLayout}
                path="*"
            />
        </Switch>
    );
};

Container.propTypes = {
    setCurrentValues: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    setCurrentValues: (data) =>
        dispatch(profile.actions.setCurrentValues(data)),
});

export default connect(null, mapDispatchToProps)(Container);
